const E400 = () => (
  <div className="error-container error-400">
    <h1>400</h1>
    <p className="title">Bad Request</p>
    <p>The server couldn't understand your request. Please check your URL or form data.</p>
  </div>
);

export default E400;